import { createAsyncThunk } from "@reduxjs/toolkit"
import { ChaingeChain, ChaingeTokenChain } from "types/baseType"
import { formatWagmiChains } from "utils"
import request from 'utils/request'
import { Chain } from "viem"

// 获取链列表
export const getSupportChains = createAsyncThunk('app/getChains', async () => {
    const {code = -1 , data = {} }: any = await request.get('/getChain')
    if(code === 0) {
        const wagmiChains: Chain[] = []
        let chainList = data.list
        const disabledChain  = ['HT', 'OKC', 'FTM', 'ETC', 'ETHW', 'ETHF', 'CAD', 'METIS', 'CIC', 'FSK', 'CRO', 'ELA', 'CFXEVM', 'FEVM', 'TELOSEVM']
        chainList = chainList.filter((item: ChaingeChain) => !disabledChain.includes(item.nickName)) 

        chainList.forEach((item: ChaingeChain) => {
            const wagmiChainItem: Chain = formatWagmiChains(item)
            wagmiChains.push(wagmiChainItem)
        });
        return {
            chains: chainList,
            wagmiChains
        }
    }
    return ''
})

// 获取资产列表
export const getSupportAssets = createAsyncThunk('app/getAssets', async () => {
    const {code = -1, data = {}}: any = await request.get('/getAssets')
    if(code === 0) {
        const tokenList = data.list as ChaingeTokenChain[]
        const newTokenList = tokenList.map((item: ChaingeTokenChain) => {
            const contractObj = item.contracts
            const chainNameKey = Object.keys(contractObj)
            item['chainList'] = chainNameKey
            return item
        })
        return newTokenList
    }
    return ''
})

